import React, { useState, useEffect } from "react";
import styles from "./bookList.module.css";
import Pagination from "../../../Components/Pagination/Pagination";
import { useNavigate } from "react-router-dom";

export default function DevBookList() {
  const [books, setBooks] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [searchText, setSearchText] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isSearching) {
      const fetchBooks = async () => {
        const url = `${process.env.REACT_APP_API_URL}/api/v1/books?page=${
          currentPage - 1
        }&size=20`;
        try {
          const response = await fetch(url);
          if (!response.ok) {
            throw new Error("Failed to fetch books");
          }
          const data = await response.json();
          setBooks(data.content);
          setTotalPages(data.totalPages);
          console.log(data.totalPages);
        } catch (error) {
          console.error("Error fetching books:", error);
        }
      };

      fetchBooks();
    }
  }, [currentPage, isSearching]);

  const handleSubmit = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/books?title=${searchText}&page=0&size=15`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch books");
      }
      const data = await response.json();
      setBooks(data.content);
      setTotalPages(data.totalPages);
      console.log(data.totalPages);
      setCurrentPage(1);
      setIsSearching(true); // mark search mode active
    } catch (error) {
      console.error("Error fetching books:", error);
    }
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleCreateNew = () => {
    navigate("/admin/create-new-book");
  };

  const handleEdit = (bookId) => {
    navigate(`/admin/edit-book/${bookId}`);
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.content}>
        <h2 style={{ fontSize: "2rem" }}>Books</h2>
        <span className={styles.divider}></span>
        <div className={styles.searchBarDiv}>
          <button onClick={handleCreateNew}>Create new</button>
          {isSearching && (
            <button
              onClick={() => {
                setSearchText("");
                setCurrentPage(1);
                setIsSearching(false); // exit search mode → triggers useEffect to refetch all books
              }}
            >
              Clear Search
            </button>
          )}
          <form
            className={styles.searchBar}
            onSubmit={(e) => {
              e.preventDefault(); // prevent page reload
              if (searchText.trim()) {
                handleSubmit();
              }
            }}
          >
            <input
              className={styles.search}
              type="text"
              placeholder="통합검색"
              value={searchText}
              onChange={handleSearchChange}
            />
            <button type="submit" className={styles.submitBtn}>
              검색
            </button>
          </form>
        </div>
        <table className={styles.bookTable}>
          <thead>
            <tr>
              <th>#</th>
              <th>제목</th>
              <th>상태</th>
              <th>저자/역자</th>
              <th>기능</th>
            </tr>
          </thead>
          <tbody>
            {books.map((book) => (
              <tr key={book.id}>
                <td>{book.id}</td>
                <td>{book.title}</td>
                <td>{book.status}</td>
                <td>
                  {book.bookAuthorDTOs.map((author) => author.name).join(", ")}
                </td>
                <td>
                  <button
                    className={styles.bookBtn}
                    onClick={() => handleEdit(book.id)}
                  >
                    내용 편집
                  </button>
                  <button
                    className={styles.bookBtn}
                    onClick={() => (window.location.href = `/book/${book.id}`)}
                  >
                    보기
                  </button>
                  <button className={styles.bookBtn}>감추기</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {totalPages > 1 && (
          <Pagination
            totalPages={totalPages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        )}
      </div>
    </div>
  );
}
